import Vue from 'vue'
import { ItemService, FileService } from '@/services'
import apiFiles from './api'
import { Message } from 'element-ui'

const namespaced = true

const state = {
  busy: false
}

const getters = {
  busy: state => state.busy
}

const media = [1, 2, 3, 7]

const actions = {
  createFilePromise (_context, { file, type, parentItemId }) {
    const payload = {
      name: file.name,
      parentItemId,
      mimeType: file.type,
      type,
      size: file.size
    }
    return new Promise((resolve, reject) => {
      FileService.encodeFilePresignedUrlRequest(payload)
        .then(apiFiles.postFileUpload)
        .then(FileService.decodeFilePresignedUrlResponse)
        .then(({ presignedUrl, item }) => {
          resolve({ presignedUrl, item, file })
        }).catch((error) => {
          reject(error)
        })
    })
  },
  putFileStatus ({ dispatch }, file) {
    apiFiles
      .putFileStatus(file.id)
      .then(() => {
        dispatch('setFile', file)
        Message({
          type: 'success',
          message: 'File was successfully uploaded',
          showClose: true
        })
      }).catch(() => {
        Message({
          type: 'error',
          message: 'Oops, we were unable to upload this file',
          showClose: true
        })
      })
  },
  updateFile ({ commit, dispatch }, { fileId, name, size }) {
    commit('setBusy', true)
    const payload = {
      name,
      size
    }
    FileService.encodeUpdateFileRequest(payload)
      .then(apiFiles.putUpdateFileRequest.bind(null, fileId))
      .then(FileService.decodeUpdateFileResponse)
      .then(({ item }) => {
        dispatch('modal/hideAllModals', {}, { root: true })
        dispatch('setFile', item)
        commit('setBusy', false)
        Message({
          type: 'success',
          message: 'File was successfully renamed',
          showClose: true
        })
      }).catch(() => {
        commit('setBusy', false)
        Message({
          type: 'error',
          message: 'Oops, we were unable to rename this file',
          showClose: true
        })
      })
  },
  moveFile ({ commit, dispatch }, { file, parentItemId }) {
    commit('setBusy', true)
    apiFiles
      .moveFile({ fileId: file.id, parentItemId })
      .then(ItemService.decodeItem)
      .then((item) => {
        dispatch('modal/hideAllModals', {}, { root: true })
        dispatch('removeFile', file)
        dispatch('setFile', item)
        commit('setBusy', false)
        Message({
          type: 'success',
          message: 'File was successfully moved',
          showClose: true
        })
      })
      .catch(() => {
        commit('setBusy', false)
        Message({
          type: 'error',
          message: 'Oops, we were unable to move this file',
          showClose: true
        })
      })
  },
  deleteFile ({ commit, dispatch }, file) {
    commit('setBusy', true)
    apiFiles
      .deleteFile(file.id)
      .then((response) => {
        dispatch('modal/hideAllModals', {}, { root: true })
        dispatch('removeFile', file)
        commit('setBusy', false)
        Message({
          type: 'success',
          message: 'File was successfully deleted',
          showClose: true
        })
      })
      .catch(() => {
        commit('setBusy', false)
        Message({
          type: 'error',
          message: 'Oops, we were unable to delete this file',
          showClose: true
        })
      })
  },
  downloadFilePromise (_context, file) {
    return new Promise((resolve, reject) => {
      apiFiles
        .getFileDownload(file.id)
        .then(FileService.decodeDownload)
        .then(({ presignedUrl }) => {
          resolve(presignedUrl)
        }, error => {
          reject(error)
        })
    })
  },
  shareFilePromise (_context, file) {
    return new Promise((resolve, reject) => {
      apiFiles
        .postFileShare(file.id)
        .then(FileService.decodeShareLinkResponse)
        .then((response) => {
          resolve(response)
        }, error => {
          reject(error)
        })
    })
  },
  setFile ({ dispatch }, file) {
    dispatch('filesRecent/setFile', file, { root: true })
    dispatch('filesFolder/setFile', file, { root: true })
    dispatch('search/setFile', file, { root: true })
    if (media.includes(file.type)) {
      dispatch('filesMedia/setFile', { file, tab: undefined }, { root: true })
    }
  },
  removeFile ({ dispatch }, file) {
    dispatch('filesRecent/removeFile', file, { root: true })
    dispatch('filesFolder/removeFile', file, { root: true })
    dispatch('search/removeFile', file, { root: true })
    if (media.includes(file.type)) {
      dispatch('filesMedia/removeFile', { file, tab: undefined }, { root: true })
    }
  }
}

const mutations = {
  setBusy (state, value) {
    Vue.set(state, 'busy', value)
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
